import { isDate } from 'date-fns';
import { types } from 'mobx-state-tree';

/**
 * Custom MobX type which automatically parses string or numeric values
 * into a JavaScript Date object.
 *
 * Numeric values should be valid UNIX timestamps.
 * String values should be valid UTC timestamp strings or any other timestamp string supported by the Date constructor.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/Date
 */
export const DateTime = types.custom({
  name: 'DateTime',
  fromSnapshot: (dateStringOrNumber) => new Date(dateStringOrNumber),
  toSnapshot: (date) => date,
  isTargetType: (date) => isDate(date),
  getValidationMessage: (snapshot) => {
    if (snapshot === null || isNaN(new Date(snapshot).valueOf())) {
      return `${snapshot} is not a valid DateTime string or number`;
    }

    return '';
  },
});
